<section class="container pt-5 pb-lg-5 pb-md-4 pb-2">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-9 col-lg-6 d-flex flex-column align-items-center">

      <img src="assets/images/illustrations/successful-payment.svg" class="w-75 w-md-50 mt-5 pt-lg-3 pb-md-1 pb-3">
      <h1 class="h2 mt-5">Depozit finalizat cu succes</h1>

      <ng-container *ngIf="deposit">
        <p class="mt-4">🎉 Felicitari! 🎉 Depozitul tau in valoare de
          <strong>{{deposit.amount}} lei</strong> a fost inregistrat cu succes!
        </p>

        <p>Balanta contului tau este acum <strong>{{(user$ | async)?.walletAmount}} lei</strong>.</p>

        <ng-container *ngIf="{cartCount: cartCount$ | async} as data">
          <ng-container *ngIf="data.cartCount; else template">

            <p class="mb-0 fw-bold"> Ai <span class="text-primary">{{(data.cartCount > 1
                ? data.cartCount : 'un' )}}</span> {{(data.cartCount > 1 ? 'carduri' : 'card' )}} cadou in
              cos.</p>

            <p>Esti la
              un pas distanta sa oferi <span class="text-primary fw-bold">#CadoulPerfect</span></p>

            <div class="d-sm-flex my-4">
              <!-- <a [routerLink]="['/user/dashboard']" class="btn btn-lg btn-secondary w-100 w-sm-auto mb-3 mb-sm-0">Inapoi
                la
                Dashboard</a> -->
              <a [routerLink]="['/user/cos']" class="btn btn-lg btn-primary w-100 w-sm-auto">Finalizeaza
                comanda</a>
            </div>


          </ng-container>

          <ng-template #template>

            <div class="d-sm-flex my-4">
              <a [routerLink]="['/user/dashboard']" class="btn btn-lg btn-secondary w-100 w-sm-auto mb-3 mb-sm-0">Inapoi
                la
                Dashboard</a>

              <a [routerLink]="['/carduri-cadou']" class="btn btn-lg btn-primary w-100 w-sm-auto ms-sm-3">Comanda
                carduri cadou</a>
            </div>

          </ng-template>
        </ng-container>


      </ng-container>



    </div>
  </div>
</section>
